import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './effects';
import {
  AnalyticsService,
  PromoCampaignService,
  RetailRocketService,
  UserSessionAnalyticsService,
  YandexMetrikaService,
} from './services';

function initAnalyticsFactory(injector: Injector): () => void {
  return () => {
    const yandexMetrikaService = injector.get(YandexMetrikaService);
    const analyticsService = injector.get(AnalyticsService);
    const promoCampaignService = injector.get(PromoCampaignService);
    const retailRocketService = injector.get(RetailRocketService);
    const loginAnalyticsService = injector.get(UserSessionAnalyticsService);

    yandexMetrikaService.initOnClient();
    analyticsService.init();
    promoCampaignService.init();
    retailRocketService.initInBrowser();
    loginAnalyticsService.init();
  };
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initAnalyticsFactory(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class AnalyticsFeatureBrowserModule {}
